import { render, staticRenderFns } from "./PccOrderAdditionalProperties.vue?vue&type=template&id=66577228&scoped=true&"
import script from "./PccOrderAdditionalProperties.vue?vue&type=script&lang=js&"
export * from "./PccOrderAdditionalProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66577228",
  null
  
)

export default component.exports